import React from 'react';
import MainLayOut from '../layout/MainLayOut';
import ProductDetailsAll from '../components/products/ProductDetailsAll';
import MobileMainLayout from '../layout/MobileMainLayout';


function ProductDetails() {
 
  return (
    <>
    <div className='hidden md:block'>
      <MainLayOut >
        <ProductDetailsAll />
      </MainLayOut>
    </div>
    <div className='md:hidden sigle_product_headline'>
      <MobileMainLayout title='MPI Plastics' link={'/'}>
        <ProductDetailsAll />
      </MobileMainLayout>
    </div>
    </>
    
  );
}

export default ProductDetails;
